import { Image, Modal, Text, Title, ActionButton } from "components/commons";
import React from "react";
import styles from "./notif-modal.module.scss";
import locale from "localization";
import { CarFormSuccess } from "images";
import classNames from "classnames";

const NotifModal = ({
  title,
  content = "",
  image = CarFormSuccess,
  primary,
  secondary,
  contentHighlight = [],
  actions = [],
  children,
  ...state
}) => {
  const {
    text: primaryText = "Got It",
    onClick: primaryOnClick = () => {
      state.close();
    },
  } = primary || {};
  const {
    text: secondaryText = "Cancel",
    onClick: secondaryClick = () => {
      state.close();
    },
  } = secondary || {};
  return (
    <Modal {...state}>
      <div className={classNames(styles.container)}>
        <Image src={image} className={styles.image} />
        <Title small className={styles.title}>
          {title}
        </Title>
        <Text className={styles.content}>
          <locale.Populate text={content} items={contentHighlight} />
        </Text>
      </div>
      {children}
      <ActionButton
        right={secondary}
        center={!secondary}
        items={[
          ...actions,
          ...(secondary
            ? [
                {
                  onClick: () => {
                    secondaryClick();
                    state.close();
                  },
                  text: secondaryText,
                  primary: false,
                },
              ]
            : []),
          {
            onClick: () => {
              primaryOnClick();
            },
            text: primaryText,
            primary: true,
          },
        ]}
      />
    </Modal>
  );
};

export default NotifModal;
